import { useProgress } from "@react-three/drei";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import "./loading-screen.css";
import React from "react";
import { useShallow } from "zustand/react/shallow";
import { LinearProgress } from "@mui/material";
import { useViewport } from "../../../helpers";

const LoadingScreen = () => {
  const { progress } = useProgress();
  const { width } = useViewport();

  const { isSceneLoaded, setSceneIsLoaded, isCanvasReady } = useThreeJsLoader(
    useShallow((state) => {
      return {
        isSceneLoaded: state.isSceneLoaded,
        setSceneIsLoaded: state.setSceneIsLoaded,
        isCanvasReady: state.isCanvasReady,
      };
    })
  );

  // if anyone find a better idea than what's below..
  // progress cannot be in a dependance array
  if (progress === 100 && !isSceneLoaded && isCanvasReady) {
    const timeId = setTimeout(() => {
      clearTimeout(timeId);
      setSceneIsLoaded();
    }, 1000);
  }

  return (
    <div
      className={`loading-screen
    ${isSceneLoaded ? "loading-screen-started" : ""}
      `}
      style={{
        height: `${
          width >= 768 ? (width <= 844 ? "371px" : "681px") : "600px"
        }`,
      }}
    >
      <div className="loading-screen-board">
        <img
          src="/faz.png"
          alt="FanArZone Logo"
          className="loading-screen-logo"
        />
      </div>
      <LinearProgress
        style={{
          width: "75%",
          height: "5px",
        }}
      />
    </div>
  );
};

export default LoadingScreen;
